import moment from 'moment';
import { ColumnData, OrderReportHistoryProps } from '../interface/interface';
import Loading from './Loading';
import { Table } from './Table';
import { TinySpinner } from './TinySpinner';

export function OrderHistoryTable(props: OrderReportHistoryProps) {
  const columns: Array<ColumnData> = [
    {
      key: 'duration',
      header: () => 'Duration',
      cell: (info) => info.getValue(),
    },
    {
      key: 'createdAt',
      header: () => 'Generated At',
      cell: (info) => {
        const date = moment(new Date(info.getValue()));
        return date.isValid() ? moment(date).format('DD/MM/YYYY') : '-';
      },
    },
    {
      key: 'generatedBy',
      header: () => 'Generated By',
      cell: (info) => info.getValue(),
    },
    {
      key: 'status',
      header: () => 'Status',
      cell: (info) => info.getValue(),
    },
    {
      key: 'reportId',
      isColumnContainsOnlyButtons: true,
      header: () => 'Report Id',
      cell: (info) => (
        <button
          className={
            info.cell.row.original.status === 'Completed' || props.isDownloaded
              ? 'md:ml-10 bg-primary-blue-500 text-white font-semibold text-sm px-3 py-2 mx-auto rounded mt-5 md:mt-0'
              : `md:ml-10 bg-primary-blue-500 text-white font-semibold text-sm px-3 py-2 mx-auto rounded mt-5 md:mt-0 
              pointer-events-none cursor-not-allowed opacity-50`
          }
          onClick={() =>
            props.onDownloadReport(
              info.getValue(),
              info.cell.row.original.duration,
            )
          }
        >
          {props.isDownloaded ? <TinySpinner /> : 'Download'}
        </button>
      ),
    },
  ];

  return props.loading ? (
    <Loading />
  ) : (
    <div className="mb-20">
      <Table columns={columns} data={props.data} />
    </div>
  );
}
